module.exports = __webpack_public_path__ + "static/media/gaja.e947be25.jpg";